module.exports = __webpack_public_path__ + "img/edit-calendar-black-24-dp.dd2fc236.svg";